<template>
  <div>
    <div class="main-container">
      <KidHeader :profileId="profileId" :serialNumber="serialNumber" />
      <div class="profile-section mb-2">
        <div class="pl-2">
          <span>
            <a
              class="text-black"
              href="javascript:void(0)"
              @click="
                $router.push({
                  path: '/kids-device',
                  query: { profileId: this.profileId },
                })
              "
              ><i class="fas fa-long-arrow-alt-left"></i> <b>Home</b></a
            >
          </span>
        </div>
      </div>
      <div class="profile-section pt-2">
        <div class="container">
            <!-- Add Contact Form -->
            <div class="row">
            <div class="col-md-12 col-xl-12">
                <div class="contact-form-card">
                <div class="form-header d-flex justify-content-between align-items-center"
                    @click="showAddContact = !showAddContact"
                    style="cursor: pointer;">
                    <div class="d-flex align-items-center">
                        <div class="form-icon">
                            <i class="fas fa-user-plus"></i>
                        </div>
                        <h3 class="form-title mb-0 pl-2">Add New Contact</h3>
                    </div>

                    <i
                    class="fas"
                    :class="showAddContact ? 'fa-chevron-up' : 'fa-chevron-down'"
                    ></i>

                    <button
                      v-if="isContactPickerSupported"
                      :disabled="importing"
                      class="btn btn-outline-primary btn-sm ml-2"
                      @click.stop="importFromPhone"
                    >
                      <i v-if="!importing" class="fas fa-address-book"></i>
                      <i v-else class="fas fa-spinner fa-spin"></i>
                      Import from Phone
                    </button>

                </div>

                <transition name="collapse">
                    <div class="form-body" v-show="showAddContact">
                        <div class="form-group modern-input">
                        <label class="input-label">
                            <i class="fas fa-user"></i>
                            Name
                        </label>
                        <input
                            type="text"
                            v-model="name"
                            autofocus
                            class="form-control"
                            placeholder="Enter full name"
                        />
                        </div>
                        
                        <div class="form-group modern-input">
                        <label class="input-label">
                            <i class="fas fa-phone"></i>
                            Phone Number
                        </label>
                        <input
                            type="text"
                            v-model="phone"
                            class="form-control"
                            placeholder="Enter phone number"
                        />
                        </div>

                        <div class="form-group modern-input">
                          <label class="input-label">
                              <i class="fas fa-image"></i>
                              Profile Pic
                          </label>
                          <input type="file" @change="handleFileUpload" class="form-control-file mt-2">
                          <img v-if="newProfilePic" :src="newProfilePic" alt="New Profile Preview" class="img-fluid rounded border" style="max-width: 100px;">
                        </div>

                        <div class="form-group modern-input">
                        <label class="input-label">
                            <i class="fas fa-sticky-note"></i>
                            Notes
                        </label>
                        <textarea
                            class="form-control"
                            v-model="notes"
                            placeholder="Add any additional notes or comments"
                            rows="3"
                        ></textarea>
                        </div>
                        
                        <button
                        type="button"
                        class="btn btn-add-contact"
                        @click="addContact()"
                        :disabled="isDisabled"
                        >
                        <i class="fas fa-plus-circle"></i>
                        <span v-if="!isDisabled">Add Contact</span>
                        <i v-else class="fa fa-spinner fa-spin"></i>
                        </button>
                    </div>
                </transition> 
                </div>
            </div>
            </div>

            <!-- Contacts List -->
            <div class="row mt-4">
            <div class="col-md-12 col-xl-12">
                <div class="contacts-card">
                <div class="contacts-header">
                    <div class="header-left">
                    <div class="contacts-icon">
                        <i class="fas fa-address-book"></i>
                    </div>
                    <div>
                        <h3 class="contacts-title">Saved Contacts</h3>
                        <p class="contacts-count">{{ contacts.length }} contact{{ contacts.length !== 1 ? 's' : '' }}</p>
                    </div>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table contacts-table">
                    <thead>
                        <tr>
                        <th scope="col">
                            <i class="fas fa-user me-2"></i>Name
                        </th>
                        <th scope="col">
                            <i class="fas fa-phone me-2"></i>Phone
                        </th>
                        <th scope="col" class="text-center">
                            <i class="fas fa-cog me-2"></i>Actions
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="contacts.length === 0">
                        <td colspan="4" class="empty-state">
                            <div class="empty-icon">
                            <i class="fas fa-address-book"></i>
                            </div>
                            <p class="empty-text">No contacts added yet</p>
                            <p class="empty-subtext">Start by adding your first contact above</p>
                        </td>
                        </tr>
                        <tr v-for="contact in contacts" :key="contact._id" class="contact-row">
                        <td class="contact-name">
                            <div class="name-wrapper">
                            <div class="avatar">
                                {{ getInitials(contact.name) }}
                            </div>
                            <div class="name-info">
                                <span class="name">{{ contact.name }}</span>
                                <span v-if="contact.email && contact.email != 'undefined'" class="email">{{ contact.email }}</span>
                            </div>
                            </div>
                        </td>
                        <td class="contact-phone">
                            <a :href="'tel:' + contact.phone" class="phone-link">
                                {{ contact.phone }}
                            </a>
                            <div class="phone-notes" v-if="contact.notes">
                                {{ contact.notes }}
                            </div>
                        </td>

                        <td class="contact-actions text-center">
                            <button
                            class="btn-delete"
                            @click="openConfirmationModal(contact._id)"
                            title="Delete contact"
                            >
                            <i class="fas fa-trash-alt"></i>
                            </button>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                </div>
            </div>
            </div>
        </div>
      </div>
      <!-- Contact Delete Confirmation Modal -->
    <div class="modal fade" id="confirmationModal" tabindex="-1" role="dialog" aria-labelledby="confirmAccessModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-danger" id="confirmAccessModalLabel">Confirmation <i class="fas fa-exclamation-triangle"></i></h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Are you sure you want to delete this contact?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="deleteContact(selectedContactId)">Yes Delete It</button>
            </div>
            </div>
        </div>
    </div>
      <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
    </div>
  </div>
</template>
<script>
import KidHeader from "@/components/KidHeader.vue";
import KidFooter from "@/components/KidFooter.vue";
import ProfileService from "../../services/ProfileService";
export default {
  name: "Contacts",
  components: {
    KidHeader,
    KidFooter,
  },
  computed: {
    isContactPickerSupported() {
      return (
        'contacts' in navigator &&
        'select' in navigator.contacts
      );
    }
  },
  data() {
    return {
      isDisabled: false,
      showAddContact: false,
      profileId: this.$route.query.profileId,
      serialNumber: this.$route.query.serialNumber,
      name: "",
      email: "",
      phone: "",
      notes: "",
      contacts: [],
      confirmationModal: false,
      selectedContactId : null,
      imagePayload: null,
      newProfilePic: null,
      previewImage: null,
      importing: false,
      importResults: {
        success: [],
        failed: []
      }
    };
  },
  methods: {
    handleFileUpload(event) {
        const file = event.target.files[0];
        this.imagePayload = file;
        if (file) {
            this.newProfilePic = URL.createObjectURL(file);
        }
    },
    async addContact() {
      this.isDisabled = true;
      let formData = new FormData();
      formData.append("profile_id", this.profileId);
      formData.append("serialNumber", this.serialNumber); 
      formData.append("name", this.name)
      formData.append("phone", this.phone);
      formData.append("notes", this.notes);
      formData.append("image", this.imagePayload);
      /*let data = {
        profile_id: this.profileId,
        serialNumber: this.serialNumber,
        name: this.name,
        phone: this.phone,
        notes: this.notes,
      };*/
      
      await ProfileService.addContact(formData)
        .then((response) => {
          this.applyPolicy()
          this.isDisabled = false;
          this.name = "";
          this.phone = "";
          this.notes = "";
          this.image = "";
          this.newProfilePic = "";
          this.$toast.success(response.data.respones_msg);
          this.getContacts();
        })
        .catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async getContacts() {
      let data = {
        profileId: this.profileId,
        serialNumber: this.serialNumber
      };
      await ProfileService.listContact(data)
        .then((response) => {
          this.contacts = response.data.data;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async deleteContact(id) {
        $('#confirmationModal').modal('hide');
        let data = {
          id: id,
        };
        await ProfileService.deleteContact(data)
          .then((response) => {
            this.applyPolicy()
            this.$toast.success(response.data.respones_msg);
            this.getContacts();
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    applyPolicy() {
      this.isDisabled = true;
      let data = {
        profile_id: this.profileId,
        serialNumber: this.serialNumber
      };

      ProfileService.applyPolicy(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
        })
        .catch((e) => {
          this.isDisabled = false;
          //this.$toast.error(e.response.data.respones_msg);
        });
    },
    getInitials(name) {
      if (!name) return '?';
      const parts = name.trim().split(' ');
      if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },
    openConfirmationModal(contactId) {
        this.selectedContactId = contactId
        $('#confirmationModal').modal('show');
    },
    async importFromPhone() {
      if (!this.isContactPickerSupported) {
        this.$toast.error('Contact import not supported on this device');
        return;
      }
      this.importResults = { success: [], failed: [] };
      try {
        const selectedContacts = await navigator.contacts.select(
          ['name', 'tel', 'icon', 'email'],
          { multiple: true }
        );

        if (!selectedContacts.length) {
          this.$toast.info('No contacts selected');
          return;
        }
        this.importing = true;
        for (const contact of selectedContacts) {
          const name = contact.name?.[0];
          const phone = contact.tel?.[0];
          const icon = contact.icon?.[0];
          const email = contact.email?.[0];
      
          if (!name || !phone) {
            this.importResults.failed.push({
              name: name || 'Unknown',
              reason: 'Missing name or phone number'
            });
            continue;
          }

          try {
            await this.addImportedContact(name, phone, email);
            this.importResults.success.push(name);
          } catch (err) {
            this.importResults.failed.push({
              name,
              reason: err?.response?.data?.respones_msg || 'Failed to add contact'
            });
          }
        }
        this.importing = false;
        //this.$toast.success('Contacts imported successfully');
        this.getContacts();
        this.applyPolicy()
        this.showImportSummary();

      } catch (err) {
        this.$toast.error(err.message || 'Failed to import contacts');
      }
    },
    async addImportedContact(name, phone, email) {
      const formData = new FormData();
      formData.append('profile_id', this.profileId);
      formData.append('serialNumber', this.serialNumber);
      formData.append('name', name);
      formData.append('phone', phone);
      formData.append('email', email);
      formData.append('notes', "");
      return await ProfileService.addContact(formData);
    },
    showImportSummary() {
      const successCount = this.importResults.success.length;
      const failedCount = this.importResults.failed.length;

      if (successCount) {
        this.$toast.success(`Imported ${successCount} contact(s) successfully`);
      }

      if (failedCount) {
        const messages = this.importResults.failed
          .map(f => `${f.name}: ${f.reason}`)
          .join('<br>');

        this.$toast.error(
          `Failed to import ${failedCount} contact(s)<br>${messages}`,
          { dangerouslyUseHTMLString: true }
        );
      }
    }
  },
  beforeMount() {
    this.getContacts();
  },
};
</script>
<style scoped>
/* Contact Form Card */
.contact-form-card {
  background: white;
  border-radius: 16px;
  padding: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  margin-bottom: 0;
}

.form-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #f1f5f9;
}

.form-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.3rem;
  flex-shrink: 0;
}

.form-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.form-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Modern Input */
.modern-input {
  margin-bottom: 0;
}

.input-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 0.5rem;
}

.input-label i {
  color: #94a3b8;
  font-size: 0.875rem;
}

.modern-input .form-control {
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
  transition: all 0.2s ease;
  background: #f8fafc;
}

.modern-input .form-control:focus {
  border-color: #3b82f6;
  background: white;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
  outline: none;
}

.modern-input .form-control::placeholder {
  color: #94a3b8;
}

.modern-input textarea.form-control {
  resize: vertical;
  min-height: 80px;
}

/* Add Contact Button */
.btn-add-contact {
  width: 100%;
  padding: 0.875rem;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.btn-add-contact:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.35);
}

.btn-add-contact:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Contacts Card */
.contacts-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.contacts-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 1.75rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 2px solid #e2e8f0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.contacts-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.3rem;
}

.contacts-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.125rem 0;
}

.contacts-count {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
}

/* Table */
.table-responsive {
  overflow-x: auto;
}

.contacts-table {
  margin: 0;
  width: 100%;
}

.contacts-table thead {
  background: #f8fafc;
}

.contacts-table thead th {
  font-size: 0.875rem;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  padding: 1rem 1.25rem;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.contacts-table tbody tr.contact-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid #f1f5f9;
}

.contacts-table tbody tr.contact-row:hover {
  background: #f8fafc;
}

.contacts-table tbody td {
  padding: 1.25rem;
  vertical-align: middle;
  color: #334155;
  font-size: 0.9rem;
}

/* Contact Name Cell */
.contact-name {
  min-width: 200px;
}

.name-wrapper {
  display: flex;
  align-items: center;
  gap: 0.875rem;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #1e40af;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.875rem;
  flex-shrink: 0;
  text-transform: uppercase;
}

.name-info {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.name {
  font-weight: 600;
  color: #1e293b;
  font-size: 0.95rem;
}

.email {
  font-size: 0.8rem;
  color: #64748b;
}

/* Phone Cell */
.contact-phone {
  min-width: 140px;
}

.phone-link {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  transition: all 0.2s ease;
  padding: 0.25rem 0;
}

.phone-link:hover {
  color: #2563eb;
  gap: 0.5rem;
}

.phone-link::before {
  content: '';
  display: inline-block;
  width: 6px;
  height: 6px;
  background: currentColor;
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.phone-link:hover::before {
  opacity: 1;
}

/* Notes Cell */
.contact-notes {
  max-width: 300px;
  min-width: 150px;
}

.notes-text {
  display: block;
  color: #64748b;
  font-size: 0.875rem;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* Actions Cell */
.contact-actions {
  min-width: 100px;
}

.btn-delete {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: #fee;
  color: #dc2626;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-delete:hover {
  background: #dc2626;
  color: white;
  transform: scale(1.1);
}

/* Empty State */
.empty-state {
  padding: 3rem 2rem !important;
  text-align: center;
}

.empty-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 1rem;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 2rem;
}

.empty-text {
  font-size: 1.125rem;
  font-weight: 600;
  color: #475569;
  margin: 0 0 0.5rem 0;
}

.empty-subtext {
  font-size: 0.875rem;
  color: #94a3b8;
  margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .contact-form-card {
    padding: 1.25rem;
  }

  .form-header {
    gap: 0.75rem;
  }

  .form-icon {
    width: 44px;
    height: 44px;
  }

  .form-title {
    font-size: 1.2rem;
  }

  .contacts-header {
    padding: 1.25rem;
  }

  .contacts-icon {
    width: 44px;
    height: 44px;
  }

  .contacts-title {
    font-size: 1.15rem;
  }

  .contacts-table {
    font-size: 0.875rem;
  }

  .contacts-table thead th,
  .contacts-table tbody td {
    padding: 0.875rem;
  }

  .avatar {
    width: 36px;
    height: 36px;
    font-size: 0.8rem;
  }

  .name {
    font-size: 0.875rem;
  }

  .contact-notes {
    max-width: 200px;
  }
}

@media (max-width: 576px) {
  .contacts-table thead th {
    font-size: 0.75rem;
    padding: 0.75rem 0.5rem;
  }

  .contacts-table tbody td {
    padding: 0.75rem 0.5rem;
  }

  .name-wrapper {
    gap: 0.625rem;
  }

  .avatar {
    width: 32px;
    height: 32px;
  }

  .contact-notes {
    max-width: 150px;
  }

  .notes-text {
    -webkit-line-clamp: 1;
  }
}
.phone-notes {
    font-size: 12px;
    color: #6b7280; /* subtle gray */
    margin-top: 2px;
}

.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.3s ease;
}
.collapse-enter-from,
.collapse-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
.collapse-enter-to,
.collapse-leave-from {
  max-height: 500px;
  opacity: 1;
}

</style>